import * as React from 'react';
import type { SVGProps } from 'react';

export const DashboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="15"
    height="15"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <rect x="3" y="3" width="8" height="8" fill="currentColor" />
    <rect x="13" y="3" width="8" height="4" fill="currentColor" />
    <rect x="13" y="9" width="8" height="2" fill="currentColor" />
    <rect x="3" y="13" width="4" height="8" fill="currentColor" />
    <rect x="9" y="13" width="12" height="8" fill="currentColor" />
  </svg>
);

